import { createFileRoute } from "@tanstack/react-router";
import PublicNav from "@/components/PublicNav";
import { ContactForm } from "@/components/contact/ContactForm";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/contact")({
  head: () =>
    seoHead({
      title: "Contact LeadXkids | Message Our Team",
      description:
        "Questions about courses, membership or your child's progress? Leave your phone number and a message and the LeadXkids team will get back to you.",
      canonical: "/contact",
    }),
  component: ContactPage,
});

function ContactPage() {
  return (
    <div className="min-h-screen bg-background">
      <PublicNav />
      <main className="mx-auto max-w-md px-4 py-10">
        <h1 className="text-2xl font-bold text-foreground">Contact LeadXkids</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Questions, feedback, or something you'd like to share with our founder? Send it here and we'll reply on your phone.
        </p>
        <div className="mt-6 rounded-2xl border border-border bg-card p-5">
          <ContactForm source="contact_page" />
        </div>
      </main>
    </div>
  );
}
